import { render, staticRenderFns } from "./BookingSpacePage.vue?vue&type=template&id=36315c77&scoped=true"
import script from "./BookingSpacePage.vue?vue&type=script&lang=js"
export * from "./BookingSpacePage.vue?vue&type=script&lang=js"
import style0 from "./BookingSpacePage.vue?vue&type=style&index=0&id=36315c77&prod&style=true&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "36315c77",
  null
  
)

export default component.exports